import { NavLink } from 'react-router-dom';
import logo from '../website-logos/Brocon-Logo-white.svg';
import './header.css';
import MobileMenu from './mobileMenu'

function Header() {
  return (
    <div className='header'>
      <div className='logoSVG'>
      <NavLink to='/'><img src={logo} className="brocon-logo" alt="logo" /></NavLink>
      </div>
      <div className='mobileMenu'>
        <MobileMenu />
      </div>
      <div className='nav-links-DT'>
          <ul>
            <li><a href='/about-us'>About Us</a></li>
            {/* <li><a href='#our-team' >Divisions</a></li> */}
            <li><a href='#portfolio' >Projects</a></li>
            <li><a href='#clients' >Our Clients</a></li>
            {/* <li><NavLink to='/careers'>Careers</NavLink></li> */}
            {/* <li><NavLink to='/contact-us'>Contact US</NavLink></li> */}
          </ul>
      </div>
    </div>
  );
}

export default Header;
